/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const linkedin_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#linkedin_medium_svg__a)">
      <path
        fill="#000"
        d="M5.619 22.75v.75a.75.75 0 0 0 .75-.75h-.75Zm-4.869 0H0c0 .414.336.75.75.75v-.75Zm0-13.99v-.75a.75.75 0 0 0-.75.75h.75Zm4.869 0h.75a.75.75 0 0 0-.75-.75v.75Zm7.964 13.99v.75a.75.75 0 0 0 .75-.75h-.75Zm-5.12 0h-.75c0 .414.337.75.75.75v-.75Zm0-13.99v-.75a.75.75 0 0 0-.75.75h.75Zm5.12 0h.75a.75.75 0 0 0-.75-.75v.75Zm0 1.597h-.75a.75.75 0 0 0 1.235.572l-.485-.572ZM17.87 8.75V8h-.01l.01.75Zm5.38 14v.75a.75.75 0 0 0 .75-.75h-.75Zm-5.38 0h-.75c0 .414.336.75.75.75v-.75Zm0-7.281-.75-.004v.004h.75Zm-2.143-2.16v.75-.75ZM5.619 22H.75v1.5h4.869V22Zm-4.119.75V8.76H0v13.99h1.5ZM.75 9.51h4.869v-1.5H.75v1.5Zm4.119-.75v13.99h1.5V8.76h-1.5Zm7.964 6.709v7.281h1.5v-7.281h-1.5Zm.75 6.531h-5.12v1.5h5.12V22Zm-4.37.75V8.76h-1.5v13.99h1.5Zm-.75-13.24h5.12v-1.5h-5.12v1.5Zm4.37-.75v1.597h1.5V8.76h-1.5Zm1.235 2.169a6.012 6.012 0 0 1 3.812-1.43L17.86 8a7.512 7.512 0 0 0-4.762 1.785l.97 1.144ZM17.87 9.5c1.388 0 2.511.508 3.302 1.467.805.976 1.328 2.497 1.328 4.622H24c0-2.354-.579-4.252-1.67-5.576C21.225 8.673 19.658 8 17.87 8v1.5Zm4.63 6.09v7.16H24v-7.16h-1.5Zm.75 6.41h-5.38v1.5h5.38V22Zm-4.63.75v-7.281h-1.5v7.281h1.5Zm-2.893-10.19c-1.591 0-2.894 1.347-2.894 2.909h1.5c0-.752.65-1.41 1.394-1.41v-1.5Zm2.893 2.912c.008-1.569-1.3-2.912-2.893-2.912v1.5c.75 0 1.397.657 1.393 1.405l1.5.007ZM4.75 3.625c0 .897-.728 1.625-1.625 1.625v1.5c1.726 0 3.125-1.4 3.125-3.125h-1.5ZM3.125 5.25A1.625 1.625 0 0 1 1.5 3.625H0C0 5.351 1.4 6.75 3.125 6.75v-1.5ZM1.5 3.625C1.5 2.728 2.228 2 3.125 2V.5A3.125 3.125 0 0 0 0 3.625h1.5ZM3.125 2c.897 0 1.625.728 1.625 1.625h1.5C6.25 1.899 4.85.5 3.125.5V2Z"
      />
    </g>
    <defs>
      <clipPath id="linkedin_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default linkedin_medium
